import { KendoBaseComponent, KendoBaseDatasourceComponent } from '@progress/kendo-base-components-vue-wrapper'
import AutoCompleteProps from './AutoCompleteProps'

import Animation from '../Common/Animation'
import Virtual from '../Common/Virtual'

export default {
    props: AutoCompleteProps,
    render(createElement) {
        return createElement('input', [
            this.$slots['kendo-datasource']
        ])
    },
    mixins: [
        KendoBaseComponent,
        KendoBaseDatasourceComponent,
        Animation,
        Virtual
    ],
    model:{
        event: 'changemodel'
    },
    mounted() {
        var that = this
        var widgetElement = that.$el
        kendo.jQuery(widgetElement).kendoAutoComplete(that.widgetOptions)
        that.$emit('kendowidgetready', that.kendoWidget())

        that.kendoWidget().bind('change', function(){
            that.$emit('changemodel', widgetElement.value)
        })
    },
    methods: {
        kendoWidget() {
            var widgetElement = this.$el

            return kendo.jQuery(widgetElement).getKendoAutoComplete()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dropdowns-vue-wrapper/src/KendoAutoComplete/KendoAutoCompleteMixin.js